/* global angular */
angular.module('ua5App')
    .directive('autofocusInput', ['$timeout', function($timeout) {
        return {
            restrict: 'A',
            link: function($scope, $element, $attrs) {
                $timeout(function() {
                    $element
                        .focus()
                        .typeahead('val', $scope.ctrl.initialValue)
                    ;
                });
            }
        };
    }])
;
